import CheckboxLabel from "./CheckboxLabel";
import _ from "lodash";
import useViewNextMessage from "../views/Vote/Utilities/hooks/useViewNextMessage";
import {getCapitalizedWords} from "_helpers";

/**
 * @param sourceName the platform of the message being replied to; defaults to the next vote message's platform
 */
export default function CloseTicketCheckbox({checked, value, handleCloseTicket, sourceName}) {
    const {message} = useViewNextMessage();
    const platformName = getCapitalizedWords(sourceName || _.get(message, 'sourceName'));

    const onChange = (event) => {
        const name = _.get(event, 'target.name');
        const value = _.get(event, 'target.checked');
        handleCloseTicket({name, value})
    }

    return(
        <CheckboxLabel
            name={'closeTicket'}
            checked={checked}
            value={value}
            label={`Close ticket on ${platformName}`}
            onChange={onChange}
        />
    )
}
